import { createAITrainingEntry } from './createAITraining';
import { updateAITrainingEntry } from './updateAITraining';
import fetchAIPromptHistory from './fetchAIPromptHistory';

interface AITraining {
  id: string;
  orgID: string;
  service: string;
  name: string;
  description?: string;
  prompt: string;
  revision: number;
  status?: string;
  users?: string[];
  public?: boolean;
  createdBy?: string;
  lastUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export async function saveAIPrompt(
  service: 'recorder' | 'askRecorder' | 'askPaiv',
  prompt: string
): Promise<any> {
  try {
    // @ts-ignore
    const { me } = global;

    const name =
      service === 'recorder'
        ? 'Recorder AI Prompt'
        : service === 'askRecorder'
        ? 'Ask Recorder AI Prompt'
        : 'Ask Paiv AI Prompt';
    const description =
      service === 'recorder'
        ? 'AI prompt for transcription and summarization in the Recorder tool'
        : service === 'askRecorder'
        ? 'AI prompt for accessing audio transcriptions to help coach users'
        : 'AI prompt for Ask Paiv assistant responses';

    // Get all prompts for this service
    const allVersions = await fetchAIPromptHistory(me.orgID, service);

    // Find current production prompt and demote it to draft
    const currentProduction = allVersions.find(
      (prompt: AITraining) => prompt.status === 'production'
    );
    if (currentProduction) {
      await updateAITrainingEntry({
        id: currentProduction.id,
        status: 'draft',
      });
      console.log(
        `Demoted previous production prompt ${currentProduction.id} to draft`
      );
    }

    // Get the next revision number - decimal increment (1.0, 1.1, 1.2, etc.)
    let nextRevision = 1.0;

    if (allVersions.length > 0) {
      const maxRevision = Math.max(...allVersions.map((v: any) => v.revision));
      // Increment by 0.1 and round to 1 decimal place to avoid floating point issues
      nextRevision = Math.round((maxRevision + 0.1) * 10) / 10;
    }

    // Create a new version and mark it as production
    return await createAITrainingEntry({
      orgID: me.orgID,
      service,
      name,
      description,
      prompt,
      revision: nextRevision,
      status: 'production', // New prompts are automatically marked as production
      public: false,
      createdBy: me.id,
      lastUpdatedBy: me.id,
    });
  } catch (error) {
    console.error('Error saving AI prompt:', error);
    throw error;
  }
}
